import React, { useCallback, useState } from "react";
import { Row, Col } from "antd";

import { getEntities } from "../../modules/crudOperations";
import { parseDateTime } from "../../modules/consignmentFunctions";
import TemplateListTable from "../../components/templateList/templateListTable";
import TemplateListFilter from "../../components/templateList/templateListFilter";
import TemplateListHeader from "../../components/templateList/templateListHeader";

function TemplateList() {
  const [templates, setTemplates] = useState();
  const loadTemplates = useCallback((parameters) => {
    getEntities(
      "consignment/template",
      setTemplates,
      (c) => ({
        key: c.id,
        templateName: c.templateName,
        insertionDateTime: parseDateTime(c.insertionDateTime),
        creator: c.creatorUser,
        json: JSON.stringify(c),
      }),
      parameters
    );
  }, []);

  const [showFilter, setShowFilter] = useState();
  const handleFilterClick = useCallback(() => {
    setShowFilter(!showFilter);
  }, [showFilter]);

  return (
    <Row>
      <Col>
        <TemplateListHeader
          templates={templates}
          showFilter={showFilter}
          loadTemplates={loadTemplates}
          onFilterClick={handleFilterClick}
        />
        <TemplateListFilter
          showFilter={showFilter}
          loadTemplates={loadTemplates}
          onSetShowFilter={setShowFilter}
        />
        <TemplateListTable
          templates={templates}
          loadTemplates={loadTemplates}
        />
      </Col>
    </Row>
  );
}

export default TemplateList;
